import storage from "redux-persist/lib/storage";
import { clearUser } from "./auth/userSlice";

const clearPersistedStateMiddleware = (store) => (next) => async (action) => {
	if (action.type === clearUser.type) {
		const persistedState = await storage.getItem("persist:root");
		if (persistedState) {
			const parsedState = JSON.parse(persistedState);
			await storage.removeItem("persist:root");
			if (parsedState && parsedState.user) {
				delete parsedState.user;
				await storage.setItem("persist:root", JSON.stringify(parsedState));
			}
		}
	}
	return next(action);
};

export default clearPersistedStateMiddleware;
